import { createContext, useState } from 'react'

import { DrawerMenu } from 'components'

interface IDrawerContext {
  isOpen: boolean
  handleDrawer: (_state: boolean) => void
  menuType: string
  setMenuType: (_newValue: string) => void
}

export const DrawerContext = createContext<IDrawerContext | null>(null)

export const DrawerProvider = ({ children }) => {
  const [isOpen, handleDrawer] = useState<boolean>(false)
  const [menuType, setMenuType] = useState<string | undefined>()

  return (
    <DrawerContext.Provider
      value={{ handleDrawer, isOpen, menuType, setMenuType }}
    >
      <DrawerMenu />
      {children}
    </DrawerContext.Provider>
  )
}
